import { useEffect, useRef, useState } from "react";
import DOMPurify from "dompurify";
import { LanguageToggle } from "./LanguageToggle";
import { Experiments, useExperiment } from "@/modules/experiments/src";

interface FooterComponentProps {
  footerData?: string;
  hasError: boolean;
}

export const FooterComponent = ({
  footerData,
  hasError,
}: FooterComponentProps) => {
  const footerRef = useRef<HTMLDivElement>(null);
  const { isExperimentVariant } = useExperiment();
  const isFooterEnabledExperiment = isExperimentVariant(
    Experiments.HEADER_FOOTER.name,
    Experiments.HEADER_FOOTER.variants.available
  );
  const [footer, setFooter] = useState("");

  useEffect(() => {
    if (isFooterEnabledExperiment && footerData) {
      setFooter(
        DOMPurify.sanitize(footerData, {
          ADD_TAGS: ["link", "script"],
          ADD_ATTR: [
            "href",
            "rel",
            "src",
            "type",
            "crossorigin",
            "onclick",
            "id",
          ],
          ALLOW_UNKNOWN_PROTOCOLS: true,
        })
      );
    }
  }, [isFooterEnabledExperiment, footerData]);

  useEffect(() => {
    if (footerRef.current && footer) {
      const scripts = footerRef.current.querySelectorAll("script");
      scripts.forEach((script) => {
        const newScript = document.createElement("script");
        if (script.src) {
          newScript.src = script.src;
        } else {
          newScript.textContent = script.textContent;
        }
        script.parentNode?.replaceChild(newScript, script);
      });
    }
  }, [footer]);

  return (
    <>
      <LanguageToggle />
      {isFooterEnabledExperiment && !hasError && footer && (
        <div
          ref={footerRef}
          dangerouslySetInnerHTML={{ __html: footer }}
          title="avion-footer"
          className="rbc-footer"
        />
      )}
    </>
  );
};
